module.exports = __webpack_public_path__ + "img/customers.1708c001.png";